import { Box } from '@mui/material'
import { DeliveriesForPlace } from 'types/model/order'
import { ORDER_STATUS } from 'types/api/order'
import { renderToStaticMarkup } from 'react-dom/server'
import { divIcon } from 'leaflet'
import { Marker } from 'react-leaflet'
import { getDriverPosition, getDriverPositionCoordinates } from './utils'

export const DriverMarker = ({
  shipmentsInOrder,
  oneShipmentSelected,
}: {
  shipmentsInOrder: DeliveriesForPlace[]
  oneShipmentSelected: boolean
}) => {
  if (shipmentsInOrder.length < 1) {
    return null
  }
  if (
    shipmentsInOrder[0].orderStatus !== ORDER_STATUS.DELIVERING ||
    !oneShipmentSelected
  ) {
    return null
  }
  const driverMarker = renderToStaticMarkup(
    <Box
      sx={{
        height: '12px',
        width: '12px',
        borderRadius: '50%',
        backgroundColor: shipmentsInOrder[0].color,
        boxShadow: `0 0 0 6px ${shipmentsInOrder[0].color}40`,
        marginLeft: '3px',
        marginTop: '3px',
      }}
    />
  )
  const driverIcon = divIcon({
    html: driverMarker,
    className: 'driver_marker',
    iconSize: [18, 18],
    iconAnchor: [9, 9],
  })

  const driverOrder = getDriverPosition(shipmentsInOrder)
  const driverCoordinates = getDriverPositionCoordinates(
    shipmentsInOrder,
    driverOrder
  )

  if (!driverCoordinates) return null
  return <Marker position={driverCoordinates} icon={driverIcon} />
}
